<ion-content>
  <div (click)="onPopState()" class="close-btn"></div>
  <div class="page-title modal-title">{{title}}</div>
  <app-form-group (onEvent)="onEvent($event)" [editForm]="editForm" [inputFormConfig]="formConfig" [newForm]="newForm"
                  [reportID]="reportID"></app-form-group>
</ion-content>
